// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fefq-grid-section .k-grid .k-detail-cell .k-detail-cell {
  padding-left: 0 !important;
  border-left: solid 12px #F4901D !important;
}
.fefq-grid-section .k-grid .k-detail-cell table {
  width: 100%;
}
.fefq-grid-section .k-grid .k-detail-cell table td {
  padding: 8px !important;
  width: auto;
}
.fefq-grid-section .k-grid .k-detail-cell table td.icon-td {
  width: 40px;
}
.fefq-grid-section .k-grid .k-detail-cell table td.p-l-20 {
  padding-left: 40px !important;
}
.fefq-grid-section td.gr {
  width: min-content;
  background-color: #eee;
}
.fefq-grid-section .orange-cl {
  color: orange;
  font-size: 12px;
  padding: 3px;
}
.fefq-grid-section tr.b-b-0 {
  border-bottom: 0 !important;
}
.fefq-grid-section .t-a-r {
  text-align: right;
}
.fefq-grid-section .k-grid table tr:hover td {
  background: rgb(241, 241, 241) !important;
  cursor: pointer !important;
}
.fefq-grid-section .k-grid .k-header {
  white-space: normal !important;
  font-size: 15px !important;
  font-weight: 500 !important;
  background: #f7f7f7;
  color: #000000;
  padding: 8px 8px !important;
}
.fefq-grid-section .k-grid .k-column-title {
  white-space: normal;
}
.fefq-grid-section table.table-history td,
.fefq-grid-section table.table-history tr {
  width: auto;
  border-bottom: 0;
}
.fefq-grid-section .k-command-cell > .k-button {
  font-size: 18px;
  padding: 0;
}

.receipt-btn {
  color: #125798;
  cursor: pointer;
}

.display-row {
  display: inline-block;
}

.blue-icon {
  color: #125798;
}

.icon-btn {
  display: inline-block;
  border: none;
  background-color: transparent;
}

.receipt-col {
  text-align: center;
}

.no-border {
  border: none;
  padding: 0;
}

.bold {
  font-weight: 700;
}

.pb-15 {
  padding-bottom: 15px;
}

.start-center {
  display: flex;
  align-items: center;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/fef-qualifying-contributions/fef-qualifying-contributions.component.scss"],"names":[],"mappings":"AAGY;EACI,0BAAA;EACA,0CAAA;AAFhB;AAIY;EACI,WAAA;AAFhB;AAGgB;EACI,uBAAA;EACA,WAAA;AADpB;AAGgB;EACI,WAAA;AADpB;AAGgB;EACI,6BAAA;AADpB;AAMI;EACI,kBAAA;EACA,sBAAA;AAJR;AAMI;EACI,aAAA;EACA,eAAA;EACA,YAAA;AAJR;AAMI;EACI,2BAAA;AAJR;AAMI;EACI,iBAAA;AAJR;AAMI;EACI,yCAAA;EACA,0BAAA;AAJR;AAMI;EACI,8BAAA;EACA,0BAAA;EACA,2BAAA;EACA,mBAAA;EACA,cAAA;EACA,2BAAA;AAJR;AAMI;EACI,mBAAA;AAJR;AAMI;;EAEI,WAAA;EACA,gBAAA;AAJR;AAMI;EACI,eAAA;EACA,UAAA;AAJR;;AAQA;EACI,cAAA;EACA,eAAA;AALJ;;AAQA;EACI,qBAAA;AALJ;;AAQA;EACI,cAAA;AALJ;;AAQA;EACI,qBAAA;EACA,YAAA;EACA,6BAAA;AALJ;;AAQA;EACI,kBAAA;AALJ;;AAQA;EACI,YAAA;EACA,UAAA;AALJ;;AAQA;EACI,gBAAA;AALJ;;AAQA;EACI,oBAAA;AALJ;;AAQA;EACI,aAAA;EACA,mBAAA;AALJ","sourcesContent":[".fefq-grid-section {\n    .k-grid {\n        .k-detail-cell {\n            .k-detail-cell {\n                padding-left: 0 !important;\n                border-left: solid 12px #F4901D !important;\n            }\n            table {\n                width: 100%;\n                td {\n                    padding: 8px !important;\n                    width: auto;\n                }\n                td.icon-td {\n                    width: 40px;\n                }\n                td.p-l-20 {\n                    padding-left: 40px !important;\n                }\n            }\n        }\n    }\n    td.gr {\n        width: min-content;\n        background-color: #eee;\n    }\n    .orange-cl {\n        color: orange;\n        font-size: 12px;\n        padding: 3px;\n    }\n    tr.b-b-0 {\n        border-bottom: 0 !important;\n    }\n    .t-a-r {\n        text-align: right;\n    }\n    .k-grid table tr:hover td {\n        background: rgb(241, 241, 241) !important;\n        cursor: pointer !important;\n    }\n    .k-grid .k-header {\n        white-space: normal !important;\n        font-size: 15px !important;\n        font-weight: 500 !important;\n        background: #f7f7f7;\n        color: #000000;\n        padding: 8px 8px !important;\n    }\n    .k-grid .k-column-title {\n        white-space: normal;\n    }\n    table.table-history td,\n    table.table-history tr {\n        width: auto;\n        border-bottom: 0;\n    }\n    .k-command-cell>.k-button {\n        font-size: 18px;\n        padding: 0;\n    }\n}\n\n.receipt-btn {\n    color: #125798;\n    cursor: pointer;\n}\n\n.display-row {\n    display: inline-block;\n}\n\n.blue-icon {\n    color: #125798;\n}\n\n.icon-btn {\n    display: inline-block;\n    border: none;\n    background-color: transparent;\n}\n\n.receipt-col {\n    text-align: center;\n}\n\n.no-border {\n    border: none;\n    padding: 0;\n}\n\n.bold {\n    font-weight: 700;\n}\n\n.pb-15 {\n    padding-bottom: 15px;\n}\n\n.start-center {\n    display: flex;\n    align-items: center;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
